// ============================================================================
// Home 首页的纯逻辑层 —— web 侧对应 Android `views/HomeLogic.kt`。
//
// 为什么单独成文件而不是留在 home-view.js 里：那个文件是 JSX，node 的测试
// runner 直接 import 会 `SyntaxError: Unexpected token '<'`。仓库里所有"能用
// 纯函数锁住的判定"都走这个形状（见 src/chat/empty-state-identity.js），
// 判定与渲染分开，判定才测得到。
// ============================================================================

/** Home 会话块的三态。 */
export const CONV_LOADING = 'loading';
export const CONV_ROWS = 'rows';
export const CONV_EMPTY = 'empty';

/**
 * 会话块该画什么。
 *
 * 抽成三个具名常量而不是在渲染里连写两个 if，是因为漏掉的恰恰是"加载中"这一
 * 档：只判 `recentChats.length > 0` 时，加载中与真·无会话在代码里长得一模一
 * 样，读代码的人看不出少了一档，也没有任何断言会红。用户看到的却是一张**可
 * 点击**的「发起新对话」卡先出现、`getWidgetChats` 回来后整块换成会话列表，
 * 高度一起跳；慢网/WebView 下这个窗口足够长到手指已经按下去。
 *
 * Android/iOS 的同一处早就有加载态（HomeView 里的注释写着这正是真机报的
 * 「我的会话不见了」），只有 web 漏了。
 *
 * 判定顺序 rows → loading → empty，即**有内容就画内容**。二次刷新（重连/回到
 * 前台）时 loading 会再次为 true，若让它优先就会把已经画好的列表闪回骨架 ——
 * 那是另一种"变脸"。骨架只在真的无内容可画时出现。
 */
export function conversationsSurface(state) {
    const rows = Array.isArray(state?.recentChats) ? state.recentChats : [];
    if (rows.length > 0) return CONV_ROWS;
    if (state?.loading) return CONV_LOADING;
    return CONV_EMPTY;
}
